import { EventApi } from 'api/ApiHelper';
import { contentsQueryKey } from 'queries/contents/queryKey';
import { useQuery } from '@tanstack/react-query';

export const useGetContentEventsQuery = (contentId: number) =>
  useQuery({
    queryKey: contentsQueryKey.contentEventList(contentId),
    queryFn: () => EventApi.getContentEvents(contentId),
  });
